<h2 mat-dialog-title>{{ data.title | resolveTranslateAbleText }}</h2>
<mat-dialog-content>
  <p class="whitespace-pre-line">{{ data.message | resolveTranslateAbleText }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="w-full flex justify-between">
    @let cancel = data.buttons.cancel;
    @if (cancel.show) {
      <button
        mat-button
        name="message-dialog-cancel-button"
        type="button"
        (click)="onClickCancel()"
        >{{ cancel?.label ?? i18nScope + '.BUTTON.CANCEL' | resolveTranslateAbleText }}</button
      >
    }
    @let submit = data.buttons.submit;
    @if (submit.show) {
      <button
        cdkFocusInitial
        mat-button
        name="message-dialog-submit-button"
        type="submit"
        (click)="onClickSubmit()"
        >{{ submit?.label ?? i18nScope + '.BUTTON.SUBMIT' | resolveTranslateAbleText }}</button
      >
    }
  </div>
</mat-dialog-actions>
